/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Directory_EmptyInputs */

const en_us2_clubs_directory_empty = /** @type {(inputs: Clubs_Directory_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No open clubs yet.`)
};

const pt_br2_clubs_directory_empty = /** @type {(inputs: Clubs_Directory_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum clube aberto por enquanto.`)
};

const es_419_clubs_directory_empty = /** @type {(inputs: Clubs_Directory_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay clubes abiertos.`)
};

const pt_pt2_clubs_directory_empty = /** @type {(inputs: Clubs_Directory_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não há clubes abertos.`)
};

const fr_fr2_clubs_directory_empty = /** @type {(inputs: Clubs_Directory_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun club ouvert pour l'instant.`)
};

const de_de2_clubs_directory_empty = /** @type {(inputs: Clubs_Directory_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine offenen Clubs.`)
};

const it_it2_clubs_directory_empty = /** @type {(inputs: Clubs_Directory_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun club aperto.`)
};

/**
* | output |
* | --- |
* | "No open clubs yet." |
*
* @param {Clubs_Directory_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_directory_empty = /** @type {((inputs?: Clubs_Directory_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Directory_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_directory_empty(inputs)
	if (locale === "es-419") return es_419_clubs_directory_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_directory_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_directory_empty(inputs)
	if (locale === "de-DE") return de_de2_clubs_directory_empty(inputs)
	if (locale === "it-IT") return it_it2_clubs_directory_empty(inputs)
	return en_us2_clubs_directory_empty(inputs)
});
export { clubs_directory_empty as "clubs.directory_empty" }